// const email = /^(([^<>()[]\.,;:s@"]+(.[^<>()[]\.,;:s@"]+)*)|(
//     ".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA
//     -Z-0-9]+.)+[a-zA-Z]{2,}))$/;
// export email;
export const isNumeric = str => (/^\d+$/).test(str)
export const isEmail = str => (/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]+)$/).test(str)
export const isValidPassword = str => (/(^(?=.*[0-9])|^(?=.*[A-Z]))[a-zA-Z\d.!\-]{8,}$/).test(str)
// export const isValidPasswordNew = str => (/(^(?=.*[0-9 ])|^(?=.*[A-Z ]))[a-z A-Z \d.!\-]{8,}$/).test(str)
// export const isValidPasswordNew = str => (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()-_=+\[{\]}|\\:;“’<,>.?/])[A-Za-z\d~`!@#$%^&*()-_=+\[{\]}|\\:;“’<,>.?/]{8,}$/).test(str) //new
export const isValidPasswordNew = str => (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/).test(str)
export const isGmail = str => (/^[a-zA-Z0-9](\.?[a-zA-Z0-9\w\D]){5,}@g(oogle)?mail\.com$/).test(str)
// export const isGmail = str => (/^[a-z0-9](\.?[a-z0-9]){5,}@g(oogle)?mail\.com$/).test(str) // jangan dipake ini salah
export const isValidDate = date =>(/^20\d{2}(-|\/)((0[1-9])|(1[0-2]))(-|\/)((0[1-9])|([1-2][0-9])|(3[0-1]))(T|\s)(([0-1][0-9])|(2[0-3])):([0-5][0-9]):([0-5][0-9])/).test(date)
export const dotRegex = /\./g;
export const commaRegex = /\,/g;
export const whiteSpaceRegex = /\s/g;
export const isINA_Phone = numString => numString.replace(/(\+62|62|^0)/,'');
export const httpRegex = /(https:\/\/)|(http:\/\/)/